var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignedOfferIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6282",
    "data-name": "Groupe 6282",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.964,
    height: 45.968,
    viewBox: "0 0 45.964 45.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5574",
    "data-name": "Trac\\xE9 5574",
    d: "M44.779,14.466a4.045,4.045,0,0,0-5.714,0l-4.052,4.055V7.849A4.013,4.013,0,0,0,33.83,4.992L30.022,1.183A4.013,4.013,0,0,0,27.165,0H4.04A4.045,4.045,0,0,0,0,4.04V41.928a4.045,4.045,0,0,0,4.04,4.04H30.974a4.045,4.045,0,0,0,4.04-4.04V29.954l9.765-9.774a4.038,4.038,0,0,0,0-5.714M31.2,29.954l-.727.727-2.857.952.952-2.857.727-.727Zm1.9-1.9-1.9-1.9,6.474-6.479,1.9,1.9ZM28.117,3.088,31.926,6.9a1.47,1.47,0,0,1,.394,1.183H26.934V2.693a1.47,1.47,0,0,1,1.183.394m2.857,40.186H4.04a1.348,1.348,0,0,1-1.347-1.347V4.04A1.348,1.348,0,0,1,4.04,2.693h20.2V9.427a1.347,1.347,0,0,0,1.347,1.347H32.32V21.217l-3.973,3.977-1.9,1.9a1.347,1.347,0,0,0-.325.526l-1.9,5.714a1.347,1.347,0,0,0,1.7,1.7l5.714-1.9a1.346,1.346,0,0,0,.526-.325l.163-.163v9.28a1.348,1.348,0,0,1-1.347,1.347m11.9-25-1.388,1.389-1.9-1.9,1.389-1.39a1.347,1.347,0,1,1,1.9,1.9",
    transform: "translate(0 0)",
    fill: "#202b53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5575",
    "data-name": "Trac\\xE9 5575",
    d: "M61.347,152.693H80.2a1.347,1.347,0,0,0,0-2.693H61.347a1.347,1.347,0,0,0,0,2.693",
    transform: "translate(-54.613 -136.533)",
    fill: "#202b53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5576",
    "data-name": "Trac\\xE9 5576",
    d: "M61.347,212.693H74.814a1.347,1.347,0,0,0,0-2.693H61.347a1.347,1.347,0,0,0,0,2.693",
    transform: "translate(-54.613 -191.146)",
    fill: "#202b53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5577",
    "data-name": "Trac\\xE9 5577",
    d: "M61.347,272.693H74.814a1.347,1.347,0,0,0,0-2.693H61.347a1.347,1.347,0,0,0,0,2.693",
    transform: "translate(-54.613 -245.759)",
    fill: "#202b53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5578",
    "data-name": "Trac\\xE9 5578",
    d: "M76.16,331.347A1.347,1.347,0,0,0,74.814,330H61.347a1.347,1.347,0,0,0,0,2.693H74.814a1.347,1.347,0,0,0,1.347-1.347",
    transform: "translate(-54.613 -300.372)",
    fill: "#202b53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5579",
    "data-name": "Trac\\xE9 5579",
    d: "M189.427,422h-8.08a1.347,1.347,0,0,0,0,2.693h8.08a1.347,1.347,0,0,0,0-2.693",
    transform: "translate(-163.84 -384.113)",
    fill: "#202b53"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedOfferIcon);
export default __webpack_public_path__ + "static/media/signed-offer-icon.d1019d520c1ddbef86d3496cd90096fc.svg";
export { ForwardRef as ReactComponent };